const studentFields = [
  {
    name: "user_uuid",
    label: "User Account",
    type: "select",
    placeholder: "Select user account",
    options: [],
  },
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    placeholder: "Type First Name",
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    placeholder: "Type Last Name",
  },
  {
    name: "mobile",
    label: "Student Mobile",
    type: "phone",
    placeholder: "9xx-xxx-xxxx",
  },
  {
    name: "nationalId",
    label: "National ID",
    type: "number",
    placeholder: "Type National ID",
  },
  {
    name: "present",
    label: "Student Present In Platform",
    type: "toggle",
    placeholder: "Select Present",
  },
  {
    name: "birth_date",
    label: "Student Birth Date",
    type: "datepicker",
    placeholder: "Select Birth Date",
  },
  {
    name: "country",
    label: "Student Country",
    type: "text",
    placeholder: "Select Country",
  },
  {
    name: "city",
    label: "Student City",
    type: "text",
    placeholder: "Select City",
  },
  {
    name: "native_lang",
    label: "Student Native Language",
    type: "text",
    placeholder: "Select Native Lang",
  },
];

export default studentFields;
